// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"603":"da4d79e0","932":"02c010b8"}[chunkId] + ".css";
};